<template>
  <div>
    <PromotionsHelperMenu/>
    <div class="loader" v-if="loadingPromotions">
      <Loader/>
    </div>
    <div v-if="!loadingPromotions" class="wrapper">
      <h2>Promocje</h2>
      <div class="promotions-wrapper">
        <Promotion
          v-for="promotion in promotions"
          :key="promotion.id"
          :id="promotion.id"
          :name="promotion.label"
          :type="promotion.promotionType"
          :stats="promotion.stats"
        />
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/event-bus";
import Loader from "@/components/Loader.vue";
import Promotion from "@/components/promotions/Promotion.vue";
import PromotionsHelperMenu from "@/components/promotions/PromotionsHelperMenu.vue";

export default {
  name: "Promotions",
  components: {
    PromotionsHelperMenu,
    Promotion,
    Loader
  },
  created() {
    this.getPromotions();
    EventBus.$on('profileChanged', () => {
      this.getPromotions();
    });
  },
  methods: {
    getPromotions() {
      this.$store.dispatch('getCurrentProfilePromotions');
    }
  },
  computed: {
    currentProfileGuid() {
      return this.$store.getters.profileGuid;
    },
    loadingPromotions() {
      return this.$store.getters.loadingPromotions;
    },
    promotions() {
      return this.$store.getters.promotions;
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 15px;
  overflow: auto;
  height: calc(100vh - 140px);
}
.promotions-wrapper {
  display: grid;
  grid-gap: 10px;
  justify-items: center stretch;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  width: 100%;
  overflow: auto;
  max-height: calc(100% - 62px);
}
</style>
